<template>
    <div class="header">
        <div class="safe-area">
            <ul class="list-inline mb-0 hidden-babylon-loading">
                <li class="list-inline-item">
                    <button type="button" class="btn btn--help" v-on:click="toggleHelp()">
                        <img class="icon" src="../assets/img/helpBlueGray.png" alt="">
                        <span class="help-text help-text--help">
							<apng v-bind:apng="require('../assets/img/hilfe_handschrift_anim.png')"
                                  v-bind:png="require('../assets/img/hilfe_handschrift_01.png')" alt="Hilfe"/>
						</span>
                    </button>
                </li>
                <li class="list-inline-item" v-if="showAudioButton">
                    <button ref="audioButton" type="button" class="btn btn--audio" v-on:click="toggleAudio()">
                        <img class="icon" src="../assets/img/audio-blueGray.png" alt="">
                        <img class="icon icon--status" src="../assets/img/audio--on-blueGray.png" alt="">
                        <span class="help-text help-text--audio">
							<apng v-bind:apng="require('../assets/img/ton_handschrift_anim.png')"
                                  v-bind:img="require('../assets/img/ton_handschrift_01.png')" alt="Ton EIN/AUS"/>
						</span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Header",
        data: () =>
        {
            return {
                showAudioButton: false
            };
        },
        created()
        {
            this.$eventBus.$on('showAudio', () =>
            {
                this.showAudioButton = true;
            });
            this.$eventBus.$on('currentPage', () =>
            {
                this.showAudioButton = false;
            });
        },
        methods: {
            toggleHelp()
            {
                this.$tracking.actionClick('Hilfe auf/zu');
                this.$eventBus.$emit('help.toggle');
            },
            toggleAudio()
            {
                this.$tracking.actionClick('Ton an/aus');
                this.$eventBus.$emit('audio.toggle');
            },
        }
    };
</script>

<style scoped lang="scss">

</style>